module.exports = __webpack_public_path__ + "static/media/alert.170c597d.mp3";